module.exports = __webpack_public_path__ + "img/orangePark.9a92460e.svg";